import { Button, Grid2 } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const RootStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(7),
  minHeight: '100%',
  marginTop: -70,
}));

export const MiddleOfThePageStyled = styled(Grid2)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 32,
  width: '100%',
  marginTop: 40,
  marginBottom: 30,
  '& .typography': {
    color: theme.palette.global.gray,
  },
}));

export const BtnStyled = styled(Button)(({ theme }) => ({
  color: theme.palette.global.white,
  fontFamily: theme.typography.button,
  fontWeight: 600,
  height: 35,
  width: 100,
  fontSize: '13px',
}));

export const SearchAndFilterStyled = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '42px',
  width: '35%',
  height: '35px',
});

export const SearchStyled = styled('div')({
  display: 'flex',
  width: '100%',
  borderRadius: '5px',
  height: '35px',
  right: '10px',
  textAlign: 'center',
  border: '1px solid #cccccccc',
});

export const TextFieldStyled = styled('input')({
  height: '35px',
  border: 'none',
  padding: '0 14px',
  fontSize: '16px',
  fontFamily: 'montserrat',
  backgroundColor: '#F2F2F2',
  outline: 'none',
  flex: 1,
});

export const ButtonInputStyled = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.global.white,
  height: '35px',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.9),
  },
}));

export const SeeMoreStyled = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  padding: '15px 30px',
}));
